import DeeperLookIcon from "../../assets/UI/DeeperLookIcon.png"
import { Link } from 'react-router-dom';
import "./ResourceBar.css"
import DictionaryIcon from "../../assets/UI/DictionaryIcon.png"

export default function ResourceBar({DeeperLook_to, Dictionary_to}){

    return(
            <div>

                <div>
                    <h1 className = "subheader-resource">Resources</h1>
                </div>
                
                <div className="resource-container">
                    
                <div className="Card-resource" id="DeeperLookIcon">
                    <Link to={DeeperLook_to}>
                    <img src={DeeperLookIcon} className="CardImage-resource" alt="Deeper Look"/>
                    </Link>
                </div>

                <div className="Card-resource">
                    <Link to={Dictionary_to}>
                    <img src={DictionaryIcon} className="CardImage-resource" alt="Dictionary"/>
                    </Link>
                </div>
                    
                </div>
            </div>

    )


}